import React from 'react';
import PrimaryButton from 'components/partials/buttons/primary-button';
import { getImage, IGatsbyImageData, getSrc, getSrcSet } from 'gatsby-plugin-image';
import { VideoData } from 'types/video-data';
import { ReactComponent as CaretRightIcon } from 'img/arrows/caret-right.svg';
import { HeroContent } from "types/hero-content";

export type HeroFeatureProps = {
    imageOnly?: boolean;
    /**
     * Main content for the hero feature image or video
     */
    heroContentMain?: HeroContent;

    heroCards?: HeroContent[];

    /**
     * The image to be displayed.
     * Width: 992px
     * Height: 636px
     */
    heroImage?: IGatsbyImageData;

    heroImageAlt?: string;

    // add a video object property with url and posterUrl image
    heroVideo?: VideoData;
};

const HeroFeature: React.FC<HeroFeatureProps> = ({ imageOnly = false, heroContentMain, heroCards, heroVideo, heroImage, heroImageAlt = '' }) => {
    const heroFeatureClass = `pattern pattern--pad hero-feature${heroContentMain ? ' hero-feature--content' : ''}${heroCards && heroCards.length > 0 && imageOnly === false ? ' hero-feature--cards' : ''}`;

    const heroImageData = getImage(heroImage || null);

    const heroImageSrc = heroImageData ? getSrc(heroImageData) : '';

    const heroImageSrcSet = heroImageData ? getSrcSet(heroImageData) : '';

    return (
        <div className={heroFeatureClass}>
            <div className="hero-feature__asset">
                {heroVideo ? (
                    <video playsInline autoPlay muted loop poster={heroVideo.posterUrl} id="bgvid">
                        <source src={heroVideo.url} type={heroVideo.type} />
                    </video>
                ) : (
                    <>{heroImageData && <img src={heroImageSrc} srcSet={heroImageSrcSet} alt={heroImageAlt} width={heroImage?.width} height={heroImage?.height} />}</>
                )}
            </div>
            {heroContentMain && imageOnly === false && (
                <div className="hero-feature__main">
                    {heroContentMain.label && <div className="label">{heroContentMain.label}</div>}
                    {heroContentMain.title && <h1 className="hero-title">{heroContentMain.title}</h1>}
                    {heroContentMain.subtext && <div className="subtext">{heroContentMain.subtext}</div>}
                    {heroContentMain.link && <PrimaryButton buttonUrl={heroContentMain.link} buttonText={heroContentMain.linkLabel} target={heroContentMain.target} />}
                </div>
            )}
            {heroCards && heroCards.length > 0 && imageOnly === false && (
                <div className="hero-feature__cards">
                    {/* loop through each heroCards */}
                    {heroCards.map((card, index) => (
                        <a href={card.link} key={index} target={card.target}>
                            <div className="label">{card.label}</div>
                            <h2 className="headline">{card.title}</h2>
                            <div className="subtext">{card.subtext}</div>
                            <div className="btn-circle-arrow"><CaretRightIcon /></div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};

export default HeroFeature;